import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'coupon-strip',
  name: '优惠券条',
  icon: '券',
  group: '商城组件',
  description: '展示领券、满减和会员活动入口',
  defaultProps: {
    title: '会员专享券',
    subtitle: '满 199 减 20，可与积分同享',
    buttonText: '去领取',
    link: '/pages/mall/index'
  }
}
